
export default (theme) => ({
  MuiInputBase: {
    styleOverrides: {
      input: {
        fontSize: '14px',
        
        [theme.breakpoints.up('md')]: {
          fontSize: '16px',
        },
        '&::placeholder': {
          lineHeight: 'normal',
          color: theme.palette.darkGrey,
          opacity: 1
        }
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: '22px',
        borderColor: theme.palette.middleGrey,
        backgroundColor: 'white',
        '&:hover, &.Mui-focused': {
          backgroundColor: theme.palette.lightGrey,
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: theme.palette.middleGrey,
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: theme.palette.middleGrey,
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: theme.palette.middleGrey,
          borderWidth: 1,
        },
        "&.Mui-error .MuiOutlinedInput-notchedOutline, & input:invalid + fieldset": {
          borderColor: theme.palette.error.form,
        },
        '& input:not(:placeholder-shown) + fieldset': {
          borderColor: theme.palette.skyBlue,
        },
        '& textarea:not([aria-hidden]):not(:placeholder-shown) ~ fieldset': {
          borderColor: theme.palette.skyBlue,
        },

        '& textarea': {
          padding: '0 8px',
        }
      },
      input: {
        padding: '9px 19px',
        color: theme.palette.darkGrey,
        minHeight: 20,
        height: 20,
        [theme.breakpoints.up('md')]: {
          padding: '12px 19px',
        }
      }
    }
  },
  MuiFormControlLabel: {
    styleOverrides: {
      label: {
        fontSize: '14px',
        [theme.breakpoints.up('md')]: {
          fontSize: '16px',
        }
      }
    }
  }
})
